<template>
  <div>
    <v-card>
      <v-toolbar v-if="newFee" dense color="grey lighten-3" flat>
        <v-icon>mdi-plus</v-icon>
        <v-toolbar-title>New Branch Fee</v-toolbar-title>
      </v-toolbar>
      <v-toolbar v-if="!newFee" dense color="grey lighten-3" flat>
        <v-icon>mdi-pencil</v-icon>
        <v-toolbar-title>Edit Branch Fee</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <message :messages="messages"></message>
        <v-container fluid grid-list-md>
          <v-layout row wrap>
            <v-flex lg6 md6 xs12>
              <v-subheader class="queryLabel">{{ labels.branch }}</v-subheader>
              <div class="title">{{ FeeForm.branch }}</div>
            </v-flex>
            <v-flex lg6 md6 xs12>
              <v-subheader class="queryLabel">{{ labels.dri }}</v-subheader>
              <div class="title">{{ DriTxt }}</div>
            </v-flex>
            <v-flex lg6 md6 xs12
              ><cal-picker
                :label="labels.effDate"
                v-model="FeeForm.effDate"
                :error-messages="errors.collect('effDate')"
                data-vv-name="effDate"
                :data-vv-as="labels.effDate"
                :min="minDate()"
                v-validate="'required|checkEffDate'"
                :disabled="!newFee"
              ></cal-picker
            ></v-flex>
            <v-flex lg6 md6 xs12
              ><v-text-field
                v-model="FeeForm.riLevyPct"
                v-num-mask="{ negative: false, intScale: 3, decScale: 4 }"
                :label="labels.riLevyPct"
                :error-messages="errors.collect('riLevyPct')"
                data-vv-name="riLevyPct"
                append-icon="mdi-percent"
                :data-vv-as="labels.riLevyPct"
                v-validate="'checkMaxPct'"
              ></v-text-field
            ></v-flex>
            <v-flex lg6 md6 xs12 v-show="showThis"
              ><v-text-field
                v-model="FeeForm.busStpPct"
                v-num-mask="{ negative: false, intScale: 3, decScale: 4 }"
                :label="labels.busStpPct"
                :error-messages="errors.collect('busStpPct')"
                data-vv-name="busStpPct"
                append-icon="mdi-percent"
                :data-vv-as="labels.busStpPct"
                v-validate="'checkMaxPct'"
              ></v-text-field
            ></v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex lg6 md6 xs12 v-show="showThis"
              ><v-text-field
                v-model="FeeForm.busTaxPct"
                v-num-mask="{ negative: false, intScale: 3, decScale: 4 }"
                :label="labels.busTaxPct"
                :error-messages="errors.collect('busTaxPct')"
                data-vv-name="busTaxPct"
                append-icon="mdi-percent"
                :data-vv-as="labels.busTaxPct"
                v-validate="'checkMaxPct'"
              ></v-text-field
            ></v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex lg6 md6 xs12
              ><v-autocomplete
                :label="labels.polStpGN"
                v-model="FeeForm.polStpGN"
                :items="GNList"
                item-text="label"
                item-value="value"
                data-vv-name="polStpGN"
                :data-vv-as="labels.polStpGN"
                :error-messages="errors.collect('polStpGN')"
                v-validate="'required'"
              ></v-autocomplete
            ></v-flex>
            <v-flex lg6 md6 xs12
              ><v-text-field
                v-model="FeeForm.polStpPct"
                v-num-mask="{ negative: false, intScale: 3, decScale: 4 }"
                :label="labels.polStpPct"
                :error-messages="errors.collect('polStpPct')"
                data-vv-name="polStpPct"
                append-icon="mdi-percent"
                :data-vv-as="labels.polStpPct"
                v-validate="'checkMaxPct'"
              ></v-text-field
            ></v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex lg6 md6 xs12
              ><v-text-field
                v-model="FeeForm.minPolStp"
                v-num-mask="{ negative: false, intScale: 7, decScale: 2 }"
                :label="labels.minPolStp"
                :error-messages="errors.collect('minPolStp')"
                data-vv-name="minPolStp"
                :data-vv-as="labels.minPolStp"
                v-validate="maxValidation(FeeForm.maxPolStp)"
              ></v-text-field
            ></v-flex>
            <v-flex lg6 md6 xs12
              ><v-text-field
                v-model="FeeForm.maxPolStp"
                v-num-mask="{ negative: false, intScale: 7, decScale: 2 }"
                :label="labels.maxPolStp"
                :error-messages="errors.collect('maxPolStp')"
                data-vv-name="maxPolStp"
                :data-vv-as="labels.maxPolStp"
              ></v-text-field
            ></v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex lg6 md6 xs12
              ><v-text-field
                v-model="FeeForm.polStpRnd"
                v-num-mask="{ negative: false, intScale: 1, decScale: 2 }"
                :label="labels.polStpRnd"
                :error-messages="errors.collect('polStpRnd')"
                data-vv-name="polStpRnd"
                :data-vv-as="labels.polStpRnd"
              ></v-text-field
            ></v-flex>
            <v-flex lg6 md6 xs12
              ><v-text-field
                v-model="FeeForm.polFee"
                v-num-mask="{ negative: false, intScale: 7, decScale: 2 }"
                :label="labels.polFee"
                :error-messages="errors.collect('polFee')"
                data-vv-name="polFee"
                :data-vv-as="labels.polFee"
              ></v-text-field
            ></v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex lg6 md6 xs12
              ><v-autocomplete
                :label="labels.polTaxGN"
                v-model="FeeForm.polTaxGN"
                :items="GNList"
                item-text="label"
                item-value="value"
                data-vv-name="polTaxGN"
                :data-vv-as="labels.polTaxGN"
                :error-messages="errors.collect('polTaxGN')"
                v-validate="'required'"
              ></v-autocomplete
            ></v-flex>
            <v-flex lg6 md6 xs12
              ><v-text-field
                v-model="FeeForm.polTaxPct"
                v-num-mask="{ negative: false, intScale: 3, decScale: 4 }"
                :label="labels.polTaxPct"
                :error-messages="errors.collect('polTaxPct')"
                data-vv-name="polTaxPct"
                append-icon="mdi-percent"
                :data-vv-as="labels.polTaxPct"
                v-validate="'checkMaxPct'"
              ></v-text-field
            ></v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex lg6 md6 xs12
              ><v-text-field
                v-model="FeeForm.minPolTax"
                v-num-mask="{ negative: false, intScale: 7, decScale: 2 }"
                :label="labels.minPolTax"
                :error-messages="errors.collect('minPolTax')"
                data-vv-name="minPolTax"
                :data-vv-as="labels.minPolTax"
                v-validate="maxValidation(FeeForm.maxPolTax)"
              ></v-text-field
            ></v-flex>
            <v-flex lg6 md6 xs12
              ><v-text-field
                v-model="FeeForm.maxPolTax"
                v-num-mask="{ negative: false, intScale: 7, decScale: 2 }"
                :label="labels.maxPolTax"
                :error-messages="errors.collect('maxPolTax')"
                data-vv-name="maxPolTax"
                :data-vv-as="labels.maxPolTax"
              ></v-text-field
            ></v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex lg6 md6 xs12
              ><v-autocomplete
                :label="labels.riskStpGN"
                v-model="FeeForm.riskStpGN"
                :items="GNList"
                item-text="label"
                item-value="value"
                data-vv-name="riskStpGN"
                :data-vv-as="labels.riskStpGN"
                :error-messages="errors.collect('riskStpGN')"
                v-validate="'required'"
              ></v-autocomplete
            ></v-flex>
            <v-flex lg6 md6 xs12
              ><v-text-field
                v-model="FeeForm.riskStpPct"
                v-num-mask="{ negative: false, intScale: 3, decScale: 4 }"
                :label="labels.riskStpPct"
                :error-messages="errors.collect('riskStpPct')"
                data-vv-name="riskStpPct"
                append-icon="mdi-percent"
                :data-vv-as="labels.riskStpPct"
                v-validate="'checkMaxPct'"
              ></v-text-field
            ></v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex lg6 md6 xs12
              ><v-autocomplete
                :label="labels.riskFeeGN"
                v-model="FeeForm.riskFeeGN"
                :items="GNList"
                item-text="label"
                item-value="value"
                data-vv-name="riskFeeGN"
                :data-vv-as="labels.riskFeeGN"
                :error-messages="errors.collect('riskFeeGN')"
                v-validate="'required'"
              ></v-autocomplete
            ></v-flex>
            <v-flex lg6 md6 xs12
              ><v-text-field
                v-model="FeeForm.riskFeePct"
                v-num-mask="{ negative: false, intScale: 3, decScale: 4 }"
                :label="labels.riskFeePct"
                :error-messages="errors.collect('riskFeePct')"
                data-vv-name="riskFeePct"
                append-icon="mdi-percent"
                :data-vv-as="labels.riskFeePct"
                v-validate="'checkMaxPct'"
              ></v-text-field
            ></v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex lg6 md6 xs12
              ><v-autocomplete
                :label="labels.riskTaxGN"
                v-model="FeeForm.riskTaxGN"
                :items="GNList"
                item-text="label"
                item-value="value"
                data-vv-name="riskTaxGN"
                :data-vv-as="labels.riskTaxGN"
                :error-messages="errors.collect('riskTaxGN')"
                v-validate="'required'"
              ></v-autocomplete
            ></v-flex>
            <v-flex lg6 md6 xs12
              ><v-text-field
                v-model="FeeForm.riskTaxPct"
                v-num-mask="{ negative: false, intScale: 3, decScale: 4 }"
                :label="labels.riskTaxPct"
                :error-messages="errors.collect('riskTaxPct')"
                data-vv-name="riskTaxPct"
                append-icon="mdi-percent"
                :data-vv-as="labels.riskTaxPct"
                v-validate="'checkMaxPct'"
              ></v-text-field
            ></v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" text @click.native="doCancel">{{ newFee ? 'Cancel' : 'Close' }}</v-btn>
        <v-btn color="primary" text @click.native="doSave">Save</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { mapGetters } from 'vuex'
import { removeFormatNumber } from '@/utils/number.js'
import isAfter from 'date-fns/isAfter'
import { removeTime } from '@/utils/date'

export default {
  props: {
    boolRefresh: {
      type: Boolean,
      default: true
    },
    branchFeeID: Object,
    branchFeeObj: Object,
    newFee: Boolean
  },
  data() {
    return {
      showThis: false,
      breadcrumb: [],
      labels: {
        branch: 'Branch',
        dri: 'Direct / RI Inwards',
        effDate: 'Effective Date',
        riLevyPct: 'RI Levy %',
        busStpPct: 'Business Stamp %',
        busTaxPct: 'Business Tax %',
        polStpGN: 'Policy Stamp on',
        polStpPct: 'Policy Stamp %',
        minPolStp: 'Minimum Policy Stamp',
        maxPolStp: 'Maximum Policy Stamp',
        polStpRnd: 'Policy Stamp Rounding value',
        polFee: 'Policy Fee',
        polTaxGN: 'Policy Tax on',
        polTaxPct: 'Policy Tax %',
        minPolTax: 'Minimum Policy Tax',
        maxPolTax: 'Maximum Policy Tax',
        riskStpGN: 'Risk Stamp on',
        riskStpPct: 'Risk Stamp %',
        riskFeeGN: 'Risk Fee on',
        riskFeePct: 'Risk Fee %',
        riskTaxGN: 'Risk Tax on',
        riskTaxPct: 'Risk Tax %',
        createdBy: 'Created By',
        modifiedBy: 'Modified By'
      },
      FeeForm: {
        branch: null,
        dri: null,
        effDate: null,
        effDate2: null,
        riLevyPct: 0,
        busStpPct: 0,
        busTaxPct: 0,
        polStpGN: 0,
        polStpPct: 0,
        minPolStp: 0,
        maxPolStp: 0,
        polStpRnd: 0,
        polFee: 0,
        polTaxGN: 0,
        polTaxPct: 0,
        minPolTax: 0,
        maxPolTax: 0,
        riskStpGN: 0,
        riskStpPct: 0,
        riskFeeGN: 0,
        riskFeePct: 0,
        riskTaxGN: 0,
        riskTaxPct: 0,
        createdBy: null,
        createdDate: null,
        modifiedBy: null,
        modifiedDate: null
      },
      GNList: [
        { label: 'G - Gross', value: 'G' },
        { label: 'N - Net', value: 'N' }
      ],
      DriTxt: '',
      loading: false,
      promptRemove: false,
      submitting: false
    }
  },
  methods: {
    minDate() {
      return new Date()
    },
    maxValidation(value) {
      const max = removeFormatNumber(value)
      return 'checkMax:' + max
    },
    async doSave() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newFee) {
            this.doCreateBranchFee()
          } else {
            // TODO
            this.doUpdateBranchFee()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doUpdateBranchFee() {
      const apiURI = this.branchMenu.updateBranchFee
      if (apiURI) {
        this.submitting = true
        try {
          this.prepFeeForm()
          const result = await this.$http.post(apiURI, this.FeeForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doCancel()
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    async doCreateBranchFee() {
      const apiURI = this.branchMenu.createBranchFee
      if (apiURI) {
        this.submitting = true
        try {
          this.prepFeeForm()
          const result = await this.$http.post(apiURI, this.FeeForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doCancel()
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    prepFeeForm() {
      if (this.FeeForm.riLevyPct === '') {
        this.FeeForm.riLevyPct = 0
      } else {
        this.FeeForm.riLevyPct = removeFormatNumber(this.FeeForm.riLevyPct)
      }
      if (this.FeeForm.busStpPct === '') {
        this.FeeForm.busStpPct = 0
      } else {
        this.FeeForm.busStpPct = removeFormatNumber(this.FeeForm.busStpPct)
      }
      if (this.FeeForm.busTaxPct === '') {
        this.FeeForm.busTaxPct = 0
      } else {
        this.FeeForm.busTaxPct = removeFormatNumber(this.FeeForm.busTaxPct)
      }
      if (this.FeeForm.polStpPct === '') {
        this.FeeForm.polStpPct = 0
      } else {
        this.FeeForm.polStpPct = removeFormatNumber(this.FeeForm.polStpPct)
      }
      if (this.FeeForm.minPolStp === '') {
        this.FeeForm.minPolStp = 0
      } else {
        this.FeeForm.minPolStp = removeFormatNumber(this.FeeForm.minPolStp)
      }
      if (this.FeeForm.maxPolStp === '') {
        this.FeeForm.maxPolStp = 0
      } else {
        this.FeeForm.maxPolStp = removeFormatNumber(this.FeeForm.maxPolStp)
      }
      if (this.FeeForm.polStpRnd === '') {
        this.FeeForm.polStpRnd = 0
      } else {
        this.FeeForm.polStpRnd = removeFormatNumber(this.FeeForm.polStpRnd)
      }
      if (this.FeeForm.polFee === '') {
        this.FeeForm.polFee = 0
      } else {
        this.FeeForm.polFee = removeFormatNumber(this.FeeForm.polFee)
      }
      if (this.FeeForm.polTaxPct === '') {
        this.FeeForm.polTaxPct = 0
      } else {
        this.FeeForm.minPolStp = removeFormatNumber(this.FeeForm.minPolStp)
      }
      if (this.FeeForm.minPolTax === '') {
        this.FeeForm.minPolTax = 0
      } else {
        this.FeeForm.minPolTax = removeFormatNumber(this.FeeForm.minPolTax)
      }
      if (this.FeeForm.maxPolTax === '') {
        this.FeeForm.maxPolTax = 0
      } else {
        this.FeeForm.maxPolTax = removeFormatNumber(this.FeeForm.maxPolTax)
      }
      if (this.FeeForm.riskStpPct === '') {
        this.FeeForm.riskStpPct = 0
      } else {
        this.FeeForm.riskStpPct = removeFormatNumber(this.FeeForm.riskStpPct)
      }
      if (this.FeeForm.riskFeePct === '') {
        this.FeeForm.riskFeePct = 0
      } else {
        this.FeeForm.riskFeePct = removeFormatNumber(this.FeeForm.riskFeePct)
      }
      if (this.FeeForm.riskTaxPct === '') {
        this.FeeForm.riskTaxPct = 0
      } else {
        this.FeeForm.riskTaxPct = removeFormatNumber(this.FeeForm.riskTaxPct)
      }
    },
    doCancel() {
      this.$emit('close')
    },
    async initForm() {
      this.resetValidator()
      this.resetMessages()
      this.FeeForm.branch = this.branchFeeID.branch
      this.FeeForm.dri = this.branchFeeID.dri
      if (this.newFee) {
        if (this.FeeForm.dri === 'D') {
          this.DriTxt = 'D -Direct'
        } else {
          this.DriTxt = 'R - RI Inwards'
        }
        const now = new Date().setHours(0, 0, 0, 0)
        this.FeeForm.effDate = new Date(now)
        this.FeeForm.riLevyPct = parseFloat(0).toFixed(4)
        this.FeeForm.busStpPct = parseFloat(0).toFixed(2)
        this.FeeForm.busTaxPct = parseFloat(0).toFixed(4)
        this.FeeForm.polStpGN = 'G'
        this.FeeForm.polStpPct = parseFloat(0).toFixed(4)
        this.FeeForm.minPolStp = parseFloat(0).toFixed(2)
        this.FeeForm.maxPolStp = parseFloat(0).toFixed(2)
        this.FeeForm.polStpRnd = parseFloat(0).toFixed(2)
        this.FeeForm.polFee = parseFloat(0).toFixed(2)
        this.FeeForm.polTaxGN = 'G'
        this.FeeForm.polTaxPct = parseFloat(0).toFixed(4)
        this.FeeForm.minPolTax = parseFloat(0).toFixed(2)
        this.FeeForm.maxPolTax = parseFloat(0).toFixed(2)
        this.FeeForm.riskStpGN = 'G'
        this.FeeForm.riskStpPct = parseFloat(0).toFixed(4)
        this.FeeForm.riskFeeGN = 'G'
        this.FeeForm.riskFeePct = parseFloat(0).toFixed(4)
        this.FeeForm.riskTaxGN = 'G'
        this.FeeForm.riskTaxPct = parseFloat(0).toFixed(4)
      } else {
        this.branchFeeObj.effDate = this.branchFeeObj.effDate2
        this.FeeForm = this.branchFeeObj
        this.FeeForm.branch = this.branchFeeID.branch
        this.FeeForm.dri = this.branchFeeID.dri
        if (this.FeeForm.dri === 'D') {
          this.DriTxt = 'D -Direct'
        } else {
          this.DriTxt = 'R - RI Inwards'
        }
      }
    }
  },
  watch: {
    boolRefresh: function (value) {
      if (value) {
        this.initForm()
      }
    }
  },
  mounted() {
    this.initForm()
  },
  created() {
    const checkMax = {
      getMessage: (field, args) => {
        if (field === 'Minimum Policy Stamp') {
          return 'The ' + field + ' should be less than Maximum Policy Stamp.'
        } else {
          return 'The ' + field + ' should be less than Maximum Policy Tax.'
        }
      },
      validate: (value, args) => {
        const val = Number(removeFormatNumber(value))
        const val2 = Number(removeFormatNumber(args))
        if (val < val2) {
          return true
        } else if (val === 0 && val2 === 0) {
          return true
        } else {
          return false
        }
      }
    }
    this.$validator.extend('checkMax', checkMax)
    const checkMaxPct = {
      getMessage: (field, args) => {
        return field + ' cannot exceed more than 100%'
      },
      validate: (value, args) => {
        return value <= 100
      }
    }
    this.$validator.extend('checkMaxPct', checkMaxPct)
    const checkEffDate = {
      getMessage: (field, args) => {
        return 'Effective date cannot be a past date'
      },
      validate: (value, args) => {
        if (value) {
          return isAfter(removeTime(value), removeTime(new Date())) || removeTime(value) >= removeTime(new Date())
        } else {
          return true
        }
      }
    }
    this.$validator.extend('checkEffDate', checkEffDate)
  },
  computed: {
    ...mapGetters(['checkAccess']),
    branchMenu() {
      return this.$store.state.branchParam.menu
    }
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>

<style>
</style>
